const footnotesBlock = document.querySelector('.wp-block-footnotes');

if (footnotesBlock) {
  /**
   * Allow footnotes to be jumped to if inside of a closed accordion block
   *
   * @param {object} event Event object
   */
  const handleFootnoteAccordion = event => {
    const tagName = event?.target?.tagName?.toLowerCase();

    // skip if the target is not an anchor tag
    if (tagName !== 'a') {
      return;
    }

    const linkId = event?.target?.closest('li')?.id;

    // skip if cannot find a footnote id
    if (!linkId) {
      return;
    }

    const footnoteAccordionItem = document
      .querySelector(`[data-fn="${linkId}"]`)
      .closest('li.wp-block-twoyou-accordionitem');

    // skip if footnote is not in an accordion or accordion already opened
    if (!footnoteAccordionItem || footnoteAccordionItem?.classList?.contains('open')) {
      return;
    }

    // toggle open the accordion with the corresponding footnote
    footnoteAccordionItem.classList.replace('close', 'open');
  };

  footnotesBlock.addEventListener('click', handleFootnoteAccordion);
}
